﻿import { createContext, useContext } from "react";

export const StaticPlotContext: React.Context<boolean> = createContext(false);
export const useStaticPlot: () => boolean = () => useContext(StaticPlotContext);